import React from 'react'

import { decode } from 'url-safe-base64'

import { orgChartClientRequiredToken, restClient0 } from 'myNet'

import classNames from 'classnames'

import avatarDefaultPNG from '@/assets/images/avatar_default.png'

const imgMap = {}

class ProfilePhoto extends React.Component {
  state = {
    imgUrl: null,
  }

  componentDidMount() {
    this.loadProfilePhoto()
  }

  componentDidUpdate(prevProps /* , prevState */) {
    const { url } = this.props
    // props의 url이 바뀌면 이미지 로딩을 다시 해줌
    if (prevProps.url !== url) {
      this.loadProfilePhoto(url)
    }
  }

  componentWillUnmount() {}

  loadProfilePhoto = () => {
    const { url } = this.props

    if (url == null || url.trim().length === 0) {
      this.setState({
        imgUrl: null,
      })
    } else if (url.indexOf('data:') === 0) {
      this.setState({
        imgUrl: url,
      })
    } else {
      const idx = url.lastIndexOf('.')
      let isImgUrl = false
      if (idx > 0) {
        const ext = url.substring(idx + 1).toLowerCase()

        switch (ext) {
          case 'ico':
          case 'bmp':
          case 'png':
          case 'svg':
          case 'gif':
          case 'jpg':
          case 'jpeg':
          case 'tif':
          case 'tiff':
            isImgUrl = true
            break
          default:
        }
      }

      if (isImgUrl === true) {
        this.setState({
          imgUrl: url,
        })
      } else if (url.trim().length > 0) {
        const protocol = url.substring(0, 8).toLowerCase()

        const onBeforeSendNew = (xhr) => {
          xhr.responseType = 'blob'
        }

        if (imgMap[url] == null) {
          let req = null
          if (protocol.indexOf('http://') === 0 || protocol.indexOf('https://') === 0) {
            req = restClient0.xhrGet(url, null, null, onBeforeSendNew, null)
          } else {
            req = orgChartClientRequiredToken.xhrGet(url, null, null, onBeforeSendNew, null)
          }

          req
            .then(async (res) => {
              console.log(' - ProfilePhoto - ', res)

              // const contentLength = res.xhr.getResponseHeader('content-length');

              // if (contentLength == null) {

              const slicedBlob = res.body.slice(0, 8)
              const checkStr = await slicedBlob.text()
              if (this.isBase64Str(checkStr) === true) {
                const str = await res.body.text()
                const contentType = res.xhr.getResponseHeader('content-type')
                const decodedStr = `data:${contentType};base64,${decode(str)}`
                // console.log(' - decodedStr - ', contentType, decodedStr);
                imgMap[url] = decodedStr
              } else {
                imgMap[url] = window.URL.createObjectURL(res.body)
              }

              this.setState({
                imgUrl: imgMap[url],
              })
            })
            .catch((error) => {
              console.error(' - ProfilePhoto - ', error)
            })
        } else {
          this.setState({
            imgUrl: imgMap[url],
          })
        }
      }
    }
  }

  isBase64Str = (str) => {
    const regex = /^[a-zA-Z0-9+/=\-_]+$/gm
    return regex.test(str)
  }

  render() {
    const { imgUrl } = this.state
    const { displayName, className, defaultUrl } = this.props

    const url = imgUrl != null ? imgUrl : defaultUrl || avatarDefaultPNG

    return (
      <span className={classNames(className)}>
        <img src={url} alt={displayName} />
      </span>
    )
  }
}

export default ProfilePhoto
